import zodJSON from 'zod-i18n-map/locales/en/zod.json'
import countries from 'i18n-iso-countries'
import countriesJSON from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(countriesJSON)

export const en = {
    zod: {
        ...zodJSON,
        custom: {
            required: 'Value required',
            invalidCountry: 'Invalid country',
            invalidZip: 'Invalid zip',
            invalidState: 'Invalid state',
            invalidTime: 'Invalid time',
            invalidDateOnly: 'Invalid date only (utc hours must be zero)',
            invalidTimeRange: 'Invalid time range',
            invalidDateRange: 'Invalid date range',
            invalidDateTimeRange: 'Invalid date time range',
            invalidRRule: 'Invalid RRule string',
            rruleMustEnd: 'The given recurring rule must have an ending',
            invalidTaxID: 'Invalid tax-id',
            invalidVATID: 'Invalid VAT-number',
            invalidCreditorIdentifier: 'Invalid creditor identifier',
            invalidBIC: 'Invalid BIC',
            invalidIBAN: 'Invalid IBAN',
            invalidSepaMandateId: 'Invalid sepa mandate-id',
            invalidObjectId: 'Invalid ObjectId',
            invalidPhone: 'Invalid phone number',
            invalidEmail: 'Invalid Email address',
            invalidOption: 'Invalid option',
            invalidReference: 'Invalid or not existent reference',
            resourceRequired: 'A file has to be selected',
            fromBeforeTo: 'Begin may not be before the end',
            duplicate: 'Duplicate value',
        },
    },
    translation: {
        language: {
            en: 'English',
            de: 'German',
        },
        timeUnit: {
            millisecond: 'Millisecond',
            milliseconds: 'Milliseconds',
            second: 'Second',
            seconds: 'Seconds',
            minute: 'Minute',
            minutes: 'Minutes',
            hour: 'Hour',
            hours: 'Hours',
            day: 'Day',
            days: 'Days',
            week: 'Woche',
            weeks: 'Wochen',
            month: 'Month',
            months: 'Months',
            quarter: 'Quarter',
            quarters: 'Quarters',
            year: 'Year',
            years: 'Years',
        },
        rruleIds: {
            repeats: 'Repeats',
            every: 'every',
            until: 'until',
            for: 'for',
            in: 'in',
            the: 'the',
            and: 'and',
            or: 'or',
            on: 'on',
            'on the': 'on the',
            last: 'last',
            st: 'st',
            nd: 'nd',
            rd: 'rd',
            th: 'th',
            time: 'time',
            times: 'times',
            hour: 'hour',
            hours: 'hours',
            minute: 'minute',
            minutes: 'minutes',
            weekday: 'weekday',
            weekdays: 'weekdays',
            day: 'day',
            days: 'days',
            week: 'week',
            weeks: 'weeks',
            month: 'month',
            months: 'months',
            year: 'year',
            years: 'years',
        },
        entities: {
            common: {
                recipientType: {
                    business: 'Business',
                    person: 'Individual',
                },
            },
        },
        form: {
            functions: {
                age: {
                    expression: 'Age',
                },
                date: {
                    expression: 'Date',
                },
                today: {
                    expression: 'Today',
                },
                number: {
                    expression: 'Number',
                },
                formatDate: {
                    expression: 'DateFormat',
                },
            },
            validators: {
                phone: {
                    name: 'Phone-Number',
                    error: 'Invalid phone-number',
                },
                mobile_phone: {
                    name: 'Mobile-Number',
                    error: 'Invalid mobile number',
                },
                url: {
                    name: 'URL / Link',
                    error: 'Invalid URL',
                },
                iban: {
                    name: 'IBAN-Number',
                    error: 'Invalid IBAN-Number',
                },
                bic: {
                    name: 'BIC-Number',
                    error: 'Invalid BIC Number',
                },
                hex_color: {
                    name: 'Color',
                    error: 'Invalid olor',
                },
                regex: {
                    name: 'Regex',
                    error: 'Invalid regex match',
                },
                email: {
                    name: 'Email',
                    error: 'Invalid email',
                },
                number: {
                    name: 'NUmber',
                    error: 'Invalid number',
                },
                text: {
                    name: 'Text',
                    error: 'Invalid text',
                },
            },
            properties: {
                text: {
                    format: {
                        displayName: 'Format',
                        text: 'Simple Text',
                        email: 'E-Mail',
                        url: 'URL / Link',
                        phone: 'Phone number',
                        mobile: 'Mobile number',
                        iban: 'IBAN',
                        bic: 'BIC',
                        number: 'Number',
                        range: 'Range',
                        date: 'Date',
                        time: 'Time',
                        dateTime: 'Date and time',
                        month: 'Month',
                        week: 'Week',
                        color: 'Color',
                        regex: 'Custom mask',
                    },
                },
                file: {
                    acceptedTypesWrapper: {
                        displayName: 'Accepted files',
                        image: 'Images',
                        video: 'Videos',
                        pdf: 'PDF Documents',
                        all: 'All files',
                    },
                },
            },
            survey: {},
        },
        tenant: {
            permissions: {
                title: 'Permissions',
                scopes: {
                    tenant: 'Tenant',
                    user: 'Administrator',
                    application: 'Application',
                    identity: 'Identities',
                },
                scopePermissions: {
                    read: 'Read',
                    insert: 'Insert',
                    edit: 'Edit',
                    remove: 'Remove',
                },
            },
            restrictions: {
                title: 'Restrictions',
                scopes: {
                    application: 'Application',
                },
            },
        },
        utils: {
            misc: {
                formatSequenceNumber: {
                    duplicateCounterPlaceholder:
                        'Another counter placeholders found at position {{position}}, but only one allowed',
                    invalidCounterPlaceholder:
                        'Invalid counter placeholder at position {{position}}, expected digit 1-9',
                    missingCounterPlaceholder: 'Missing a placeholder for the counter',
                },
            },
            email: {
                defaultEmail: {
                    name: 'Content',
                    description: 'Description',
                },
            },
        },
        misc: {
            unknown: 'Unknown',
            close: 'Close',
            fullYear: 'Ganzes Jahr',
            today: 'Today',
            yesterday: 'Yesterday',
            tomorrow: 'Tomorrow',
            untitled: 'Untitled',
            and: 'and',
            or: 'or',
            numberSeparatorWord: 'Dot',
            point: 'Point',
            pointShort: 'Pt',
            points: 'Points',
            pointsShort: 'Pts',
            freePrice: 'No charge',
            copyOf: 'Copy of {{name}}',
        },
    },
}
